//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import resume from "./component/resume.vue";
import privacyPolicy from "./component/privacyPolicy.vue";
import commportallogin from "@/pcpage/hr/recruitment/portal/commportallogin";
export default {
  extends: commportallogin,
  name: "signUp",
  components: {
    resume,
    privacyPolicy,
  },
  data() {
    return {
      step: 1, //步骤条
      statusTitle: {
        1: "Create Account",
        2: "Personal Information",
        3: "Upload Resume",
        4: "Complete Sign Up",
      },
      showRe: false,
      isSendCode: false,
      sendCodeText: "Send Code",
      ifpassworderror: false, //是否展示密码验证失败提示信息
      passwordpass: false, //验证密码是否验证成功
      passworderror: false, //验证密码是否验证失败
      passwordpass2: false, //验证密码是否验证成功
      passworderror2: false, //验证密码是否验证失败
      downloadFinished: false,
      sendCodeTime: "",
      ifcheckbox: false,
      statusImg: {
        true: require("../../../../assets/images/success.png"),
        false: require("../../../../assets/images/error1.png"),
      },
      //date1:'',
      record: {}, //用户注册信息
      url: "api/api/createAccount",
      appellationList: [],
      suffixList: [],
      genderList: [],
    };
  },
  methods: {
    completeLoading() {
      this.downloadFinished = true;
    },
    goTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    async goNext(index) {
      this.goTop();
      let flag = true;
      if (index == 2) {
        flag = await this.checkForm(index);
      }
      if (index == 3) {
        flag = await this.checkForm(index); //验证表单内容是否必填
      }
      if (index == 4) {
        flag = await this.checkForm(index);
        this.downloadFinished = true;
      }
      if (flag) {
        this.step = index;
      }
    },
    loginPage() {
      this.$router.push({
        path: "/portal/login",
        query: {},
      });
    },
    initSelect() {
      //初始化行项下拉框对应值
      let params = [];
      //初始化下拉框
      let appellation = {
        showcode: "appellationList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "APPELLATION",
          paras1: "1",
        },
      };
      let suffix = {
        showcode: "suffixList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "SUFFIX",
          paras1: "1",
        },
      };
      let gender = {
        showcode: "genderList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "GENDER",
          paras1: "1",
        },
      };
      params.push(appellation);
      params.push(suffix);
      params.push(gender);
      this.initDropDown(this, params);
    },
  },
  created() {
    this.initSelect();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/signUp.vue